import React from "react";
import "./App.css";
import SignUp from "./container/auth/SignUp";
import Login from "./container/auth/Login";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LandingPage from "./container/home/LandingPage";
import TraningLandingPage from "./container/home/TraningLandingPage";
import OrganizationDashboard from "./container/home/OrganizationDashboard";
import UserDashboard from "./container/home/UserDashboard";
import LearningProviderDashboard from "./container/home/LearningProviderDashboard";
import NotFoundPage from "./container/other/NotFoundPage";
import NotAuthorisedPage from "./container/other/NotAuthorisedPage";
import AddTrainingUser from "./container/learning_provider/AddTrainingUser";
import CreateTrainingPage from "./container/learning_provider/CreateTrainingPage";
import RegisterOrganization from "./container/organization/RegisterOrganization";
import ShowAllTrainings from "./container/learning_provider/ShowAllTrainings";
import ShowTrainingUser from "./container/learning_provider/ShowTrainingUser";
import UserWiseTraining from "./container/learning_provider/provider_user/UserWiseTraining";
import HomePage from "./container/home/HomePage";
import PlayCourse from "./container/courses/PlayCourse";
import CreateCourse from "./container/courses/CreateCourse";
import ProviderUserDashboard from "./container/learning_provider/provider_user/ProviderUserDashboard";
import OrganizationRequest from "./container/admin/OrganizationRequest";
import ShowAllOrg from "./container/admin/ShowAllOrg";
import NewRegisterOrganizations from "./container/admin/NewRegisterOrganizations";
// import CreateOrgTrainingPage from "./container/organization/CreateOrgTrainingPage";
// import ShowAllOrgTrainings from "./container/organization/ShowAllOrgTrainings";
import OrgUserDashboard from "./container/organization/org_user/OrgUserDashboard";
import EducloundMeet from "./container/EducloundMeet";
import JoinedTrainingUserDetails from "./container/learning_provider/JoinedTrainingUserDetails";
import ChangePasswordPage from "./container/auth/ChangePasswordPage";
import ForgotPassword from "./container/auth/ForgotPassword";
import ResetPassword from "./container/auth/ResetPassword";
import LearningProvidersList from "./container/admin/users/LearningProvidersList";
import AddOrgSubAdmin from "./container/organization/AddOrgSubAdmin";
import { PrivateRoute } from "./container/other/PrivateRoute";
import WhiteBoard from "./container/WhiteBoard";
import axios from "axios";
import { getToken } from "./config/api";
import AllCoures from "./container/courses/AllCoures";
import LearningProvidersUsersList from "./container/admin/users/LearningProvidersUsersList";
import AddSubAdmin from "./container/organization/org_subadmin/AddSubAdmin";
import NewOrgSubAdminRequest from "./container/admin/users/NewOrgSubAdminRequest";
import NewLearningProvidersRequest from "./container/admin/users/NewLearningProvidersRequest";
import OrgSubAdminList from "./container/admin/users/OrgSubAdminList";
import EditCourse from "./container/courses/EditCourse";
import ViewCourseByModulesAndTopic from "./container/courses/ViewCourseByModulesAndTopic";
import GCRegisterPage from "./container/google_cloud/GCRegisterPage";
import GCCreateVM from "./container/google_cloud/GCCreateVM";
import GCLoginPage from "./container/google_cloud/GCLoginPage";
import ShowVMList from "./container/google_cloud/ShowVMList";
import ShowVMDetails from "./container/google_cloud/ShowVMDetails";
import AssignUserToVM from "./container/google_cloud/AssignUserToVM";
import ShowVm from "./container/google_cloud/ShowVm";
import MainHomePage2 from "./container/home/MainHomePage2";
import ShowPricingChart from "./container/admin/ShowPricingChart";
import TestComponent from "./container/TestComponent";
import MakeVmBillings from "./container/google_cloud/MakeVmBillings";
import VMPaymentHistory from "./container/google_cloud/VMPaymentHistory";
import CoursesForUser from "./container/courses/CoursesForUser";
import { disableInspectElement } from "./config/disableInsepct";
import CommingSoon from "./container/components/CommingSoon";
import PrivacyPolicy from "./container/other/PrivacyPolicy";
import TermsAndCondition from "./container/other/TermsAndCondition";
import CategoryPage from "./container/admin/certification/CategoryPage";
import CreateCertification from "./container/admin/certification/CreateCertification";
import CreateTrainingCourse from "./container/admin/traning_course/CreateTrainingCourse";
import CertificationList from "./container/admin/certification/CertificationList";
import TrainingCourseList from "./container/admin/traning_course/TrainingCourseList";
import CertificationPdf from "./container/learning_provider/provider_user/CertificationPdf";
import UpdateUserDetails from "./container/learning_provider/UpdateUserDetails";
import ShowAllUser from "./container/learning_provider/ShowAllUser";
import HomeAllCourses from "./container/home/HomeAllCourses";
import HomeAllCertifications from "./container/home/HomeAllCertifications";
import ViewCart from "./container/payment/ViewCart";
import uuid from "react-uuid";
import AuthCart from "./container/payment/AuthCart";
import VerifyCertificate from "./container/learning_provider/provider_user/VerifyCertificate";
import ViewCouesesToUser from "./container/courses/assign_course/ViewCouesesToUser";
import AssignCourses from "./container/courses/assign_course/AssignCourses";
import AssignCourseUserList from "./container/courses/assign_course/AssignCourseUserList";
import EditCertfication from "./container/admin/certification/EditCertfication";
import CertificationDetails from "./container/home/CertificationDetails";
import AddTrainer from "./container/admin/trainer/AddTrainer";
import TrainerList from "./container/admin/trainer/TrainerList";
import AddTrainerBankDetails from "./container/trainer/AddTrainerBankDetails";
import TrainerBankDetailsList from "./container/trainer/TrainerBankDetailsList";
import UpdateTrainerProfile from "./container/trainer/UpdateTrainerProfile";
import TrainerAssignedTraining from "./container/trainer/TrainerAssignedTraining";
import TrainerHomeDashboard from "./container/trainer/TrainerHomeDashboard";
import AddTrainerSkills from "./container/trainer/AddTrainerSkills";
import TrainerSkillList from "./container/trainer/TrainerSkillList";
import TrainerProfile from "./container/trainer/TrainerProfile";
import EditTrainerBankDetails from "./container/trainer/EditTrainerBankDetails";
import UpdateTrainerSkill from "./container/trainer/UpdateTrainerSkill";
import AddTrainerCertificate from "./container/trainer/AddTrainerCertificate";
import UpdateTrainerCertificate from "./container/trainer/UpdateTrainerCertificate";
import ShowTrainerCertificate from "./container/trainer/ShowTrainerCertificate";
import ShowTrainerReference from "./container/trainer/ShowTrainerReference";
import AddtrainerReference from "./container/trainer/AddTrainerReference";
import UpdateTrainerReference from "./container/trainer/UpdateTrainerReference";
import AddTrainerReference from "./container/trainer/AddTrainerReference";
import AssignTrainerPage from "./container/learning_provider/AssignTrainerPage";
import UpdateTrainer from "./container/admin/trainer/EditTrainer";
import RegisterTrainingFrom from "./container/home/RegisterTrainingFrom";
import TestBuleButton from "./container/TestBuleButton";
import PlayRecording from "./container/learning_provider/PlayRecording";
import ShowAllCompletedTraining from "./container/learning_provider/ShowAllCompletedTraining";
import ShowTrainingDetails from "./container/learning_provider/ShowTrainingDetails";
import EndMeetingPage from "./container/EndMeetingPage";
import TakeTrainerCall from "./container/learning_provider/TakeTrainerCall";
import AddTrainingSyllabus from "./container/learning_provider/AddTrainingSyllabus";
import TrainingSyllabusList from "./container/learning_provider/TrainingSyllabusList";
import TrainingAttendance from "./container/learning_provider/TrainingAttendance";
import TrainingConferancePage from "./container/TrainingConferancePage";
import UserTrainingDetailsList from "./container/learning_provider/provider_user/UserTrainingSyllabusList";
import PublicConferencePage from "./container/PublicConferencePage";
import AddQuestionBank from "./container/learning_provider/questions/AddQuestionBank";
import ShowQuestionBank from "./container/learning_provider/questions/ShowQuestionBank";
import AssessmentTestPage from "./container/learning_provider/questions/AssessmentTestPage";
import AddAssessmentQuestion from "./container/learning_provider/questions/AddAssessmentQuestion";
import ShowLpTakeCall from "./container/learning_provider/take_call/ShowLpTakeCall";
import ViewTakeCallTrainers from "./container/learning_provider/take_call/ViewTakeCallTrainers";
//import ShowTrainerRequirementConfim from "./container/learning_provider/take_call/ShowTrainerRequirementConfim";

import TrainerTakeCall from "./container/trainer/TrainerTakeCall";

import TrainerTrainingRequirementStatus from "./container/trainer/TrainerTrainingRequirementStatus";
import ShowTrainerRequirementConfim from "./container/learning_provider/take_call/ShowTrainerRequirementConfim";
import AddService from "./container/admin/services/AddService";
import ServiceList from "./container/admin/services/ServiceList";
import EditService from "./container/admin/services/EditService";

function App() {
  if (localStorage.getItem("token")) {
    const token = getToken();
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }
  //disableInspectElement();
  const uid = localStorage.getItem("uu");
  if (!uid) {
    localStorage.setItem("uu", uuid());
  }

  return (
    <Router>
      <Routes>
        {/*Normal User */}
        <Route
          path={"/payment"}
          caseSensitive={false}
          element={<TestComponent />}
        />
        <Route
          path={"/course-list"}
          caseSensitive={false}
          element={<CoursesForUser />}
        />
        <Route
          path={"/recording"}
          caseSensitive={false}
          element={<PlayRecording />}
        />

        <Route
          path={"/end-meeting/:slug"}
          caseSensitive={false}
          element={<EndMeetingPage />}
        />
        <Route
          path={"/training-details/:slug"}
          caseSensitive={false}
          element={<ShowTrainingDetails />}
        />

        <Route
          path={"/user/training-details/:slug"}
          caseSensitive={false}
          element={<UserTrainingDetailsList />}
        />

        <Route path={"/vm/:name"} caseSensitive={false} element={<ShowVm />} />
        <Route
          path={"/my-trainings"}
          caseSensitive={false}
          element={<UserWiseTraining />}
        />
        <Route
          path={"/conference/:slug"}
          caseSensitive={false}
          element={<TestBuleButton />}
        />

        <Route
          path={"/training/start/:id"}
          caseSensitive={false}
          element={<TrainingConferancePage />}
        />

        <Route
          path={"/course/:slug"}
          caseSensitive={false}
          element={<PlayCourse />}
        />
        <Route
          path={"/white-board"}
          caseSensitive={false}
          element={<WhiteBoard />}
        />
        <Route
          path={"/training/:slug"}
          caseSensitive={false}
          element={<EducloundMeet />}
        />
        <Route
          path={"/user/courses/list"}
          caseSensitive={false}
          element={<ViewCouesesToUser />}
        />
        <Route element={<PrivateRoute allowedRoles={["user"]} />}>
          <Route
            path={"/users"}
            caseSensitive={false}
            element={<UserDashboard />}
          />
          <Route
            path={"/vm/:name"}
            caseSensitive={false}
            element={<ShowVm />}
          />
          <Route
            path={"/view-cart"}
            caseSensitive={false}
            element={<AuthCart />}
          />
        </Route>
        {/*Provider */}
        <Route element={<PrivateRoute allowedRoles={["provider"]} />}>
          <Route
            path={"/learning-provider"}
            caseSensitive={false}
            element={<LearningProviderDashboard />}
          />
        </Route>
        {/*Provider User */}
        <Route element={<PrivateRoute allowedRoles={["provider_user"]} />}>
          <Route
            path={"/lpu-home"}
            caseSensitive={false}
            element={<ProviderUserDashboard />}
          />

          <Route
            path={"/certificate/:slug"}
            caseSensitive={false}
            element={<CertificationPdf />}
          />

          <Route
            path={"/vm/:name"}
            caseSensitive={false}
            element={<ShowVm />}
          />
        </Route>
        {/*Organization */}
        <Route element={<PrivateRoute allowedRoles={["organization"]} />}>
          <Route
            path={"/organization"}
            caseSensitive={false}
            element={<OrganizationDashboard />}
          />
          <Route
            path={"/org/add-org-sub-admin"}
            caseSensitive={false}
            element={<AddOrgSubAdmin />}
          />
          <Route
            path={"/org/add-org-subadmin"}
            caseSensitive={false}
            element={<AddSubAdmin />}
          />
        </Route>
        <Route element={<PrivateRoute allowedRoles={["trainer"]} />}>
          <Route
            path={"/trainer/add-bank-details"}
            caseSensitive={false}
            element={<AddTrainerBankDetails />}
          />
          <Route
            path={"/trainer/bank-details-list"}
            caseSensitive={false}
            element={<TrainerBankDetailsList />}
          />
          <Route
            path={"/trainer/update-bank-details/:id"}
            caseSensitive={false}
            element={<EditTrainerBankDetails />}
          />

          <Route
            path={"/trainer/update-profile"}
            caseSensitive={false}
            element={<UpdateTrainerProfile />}
          />

          <Route
            path={"/trainer/profile"}
            caseSensitive={false}
            element={<TrainerProfile />}
          />

          <Route
            path={"/trainer/skill-add"}
            caseSensitive={false}
            element={<AddTrainerSkills />}
          />
          <Route
            path={"/trainer/skill-update/:id"}
            caseSensitive={false}
            element={<UpdateTrainerSkill />}
          />

          <Route
            path={"/trainer/skill-list"}
            caseSensitive={false}
            element={<TrainerSkillList />}
          />

          <Route
            path={"/trainer/certificate/add"}
            caseSensitive={false}
            element={<AddTrainerCertificate />}
          />
          <Route
            path={"/trainer/certificate/update/:id"}
            caseSensitive={false}
            element={<UpdateTrainerCertificate />}
          />

          <Route
            path={"/trainer/certificate/list"}
            caseSensitive={false}
            element={<ShowTrainerCertificate />}
          />

          <Route
            path={"/trainer/reference/add"}
            caseSensitive={false}
            element={<AddTrainerReference />}
          />
          <Route
            path={"/trainer/reference/update/:id"}
            caseSensitive={false}
            element={<UpdateTrainerReference />}
          />

          <Route
            path={"/trainer/reference/list"}
            caseSensitive={false}
            element={<ShowTrainerReference />}
          />

          <Route
            path={"/trainer/assigned-trainings"}
            caseSensitive={false}
            element={<TrainerAssignedTraining />}
          />
          <Route
            path={"/trainer-home"}
            caseSensitive={false}
            element={<TrainerHomeDashboard />}
          />
          <Route
            path={"/trainer-take-calls"}
            caseSensitive={false}
            element={<TrainerTakeCall />}
          />
          <Route
            path={"/confirm-training-requirement/:id"}
            caseSensitive={false}
            element={<TrainerTrainingRequirementStatus />}
          />
        </Route>

        {/*Organizatison User */}
        <Route element={<PrivateRoute allowedRoles={["organization_user"]} />}>
          <Route
            path={"/ou/home"}
            caseSensitive={false}
            element={<OrgUserDashboard />}
          />
          <Route
            path={"/vm/:name"}
            caseSensitive={false}
            element={<ShowVm />}
          />
        </Route>
        {/*Admin Routes */}
        <Route element={<PrivateRoute allowedRoles={["admin"]} />}>
          <Route
            path={"/admin/home"}
            caseSensitive={false}
            element={<HomePage />}
          />
          <Route
            path={"/admin/categories"}
            caseSensitive={false}
            element={<CategoryPage />}
          />
          <Route
            path={"/trainer/register"}
            caseSensitive={false}
            element={<AddTrainer />}
          />
          <Route
            path={"/trainer/list"}
            caseSensitive={false}
            element={<TrainerList />}
          />
          <Route
            path={"/trainer/update/:id"}
            caseSensitive={false}
            element={<UpdateTrainer />}
          />
          <Route
            path={"/service/create"}
            caseSensitive={false}
            element={<AddService />}
          />
          <Route
            path={"/service/list"}
            caseSensitive={false}
            element={<ServiceList />}
          />
          <Route
            path={"/service/edit:id"}
            caseSensitive={false}
            element={<EditService />}
          />

          <Route
            path={"/admin/create-training-course"}
            caseSensitive={false}
            element={<CreateTrainingCourse />}
          />
          <Route
            path={"/admin/training-course-list"}
            caseSensitive={false}
            element={<TrainingCourseList />}
          />
          <Route
            path={"/certification/create"}
            caseSensitive={false}
            element={<CreateCertification />}
          />
          <Route
            path={"/certification/edit/:id"}
            caseSensitive={false}
            element={<EditCertfication />}
          />

          <Route
            path={"/certification/list"}
            caseSensitive={false}
            element={<CertificationList />}
          />
          <Route
            path={"/admin/vm-pricing-chart"}
            caseSensitive={false}
            element={<ShowPricingChart />}
          />
          <Route
            path={"/admin/organizations"}
            caseSensitive={false}
            element={<ShowAllOrg />}
          />
          <Route
            path={"/admin/approve-organizations"}
            caseSensitive={false}
            element={<NewRegisterOrganizations />}
          />
          <Route
            path={"/admin/learning-providers"}
            caseSensitive={false}
            element={<LearningProvidersList />}
          />
          <Route
            path={"/admin/learning-provider-users-list/:slug"}
            caseSensitive={false}
            element={<LearningProvidersUsersList />}
          />
          <Route
            path={"/get-organizations"}
            caseSensitive={false}
            element={<OrganizationRequest />}
          />
          <Route
            path={"/admin/org-sub-admin-requests"}
            caseSensitive={false}
            element={<NewOrgSubAdminRequest />}
          />
          <Route
            path={"/admin/org-sub-admin"}
            caseSensitive={false}
            element={<OrgSubAdminList />}
          />
          <Route
            path={"/admin/learning-provider-requests"}
            caseSensitive={false}
            element={<NewLearningProvidersRequest />}
          />
        </Route>
        {/*Provider And Organization Routes */}
        <Route
          element={
            <PrivateRoute
              allowedRoles={["provider", "organization", "org_subadmin"]}
            />
          }
        >
          <Route
            path={"/assessment"}
            caseSensitive={false}
            element={<AssessmentTestPage />}
          />

          <Route
            path={"/take-calls"}
            caseSensitive={false}
            element={<ShowLpTakeCall />}
          />
          <Route
            path={"/take-call-trainers/:id"}
            caseSensitive={false}
            element={<ViewTakeCallTrainers />}
          />
          <Route
            path={"/trainer/requirement/confirm/:trainer_id/:take_call_id"}
            caseSensitive={false}
            element={<ShowTrainerRequirementConfim />}
          />

          <Route
            path={"/question-bank/add"}
            caseSensitive={false}
            element={<AddQuestionBank />}
          />
          <Route
            path={"/assessment/add/:slug"}
            caseSensitive={false}
            element={<AddAssessmentQuestion />}
          />

          <Route
            path={"/question-bank/show"}
            caseSensitive={false}
            element={<ShowQuestionBank />}
          />

          <Route
            path={"/course/assign-to-users/:slug"}
            caseSensitive={false}
            element={<AssignCourses />}
          />

          <Route
            path={"/add-training-syllabus/:slug"}
            caseSensitive={false}
            element={<AddTrainingSyllabus />}
          />

          <Route
            path={"/training-attendance/:id"}
            caseSensitive={false}
            element={<TrainingAttendance />}
          />

          <Route
            path={"/training-syllabus/:slug"}
            caseSensitive={false}
            element={<TrainingSyllabusList />}
          />

          <Route
            path={"/trainer/take/call/:slug"}
            caseSensitive={false}
            element={<TakeTrainerCall />}
          />

          <Route
            path={"/assing/trainer/:slug"}
            caseSensitive={false}
            element={<AssignTrainerPage />}
          />

          <Route
            path={"/course/assign-users-list/:slug"}
            caseSensitive={false}
            element={<AssignCourseUserList />}
          />
          <Route
            path={"/cloud-payment"}
            caseSensitive={false}
            element={<MakeVmBillings />}
          />
          <Route
            path={"/vm-payments-history"}
            caseSensitive={false}
            element={<VMPaymentHistory />}
          />

          <Route
            path={"/create-training"}
            caseSensitive={false}
            element={<CreateTrainingPage />}
          />

          <Route
            path={"/register-cloud-account"}
            caseSensitive={false}
            element={<GCRegisterPage />}
          />
          <Route
            path={"/authorize-cloud-account"}
            caseSensitive={false}
            element={<GCLoginPage />}
          />

          <Route
            path={"/create-vm"}
            caseSensitive={false}
            element={<GCCreateVM />}
          />
          <Route
            path={"/vm-list"}
            caseSensitive={false}
            element={<ShowVMList />}
          />
          <Route
            path={"/vm-details/:name"}
            caseSensitive={false}
            element={<ShowVMDetails />}
          />

          <Route
            path={"/assign-vm-to-user"}
            caseSensitive={false}
            element={<AssignUserToVM />}
          />

          <Route
            path={"/vm/:name"}
            caseSensitive={false}
            element={<ShowVm />}
          />

          <Route
            path={"/course/:slug"}
            caseSensitive={false}
            element={<PlayCourse />}
          />

          <Route
            path={"/course/:slug"}
            caseSensitive={false}
            element={<PlayCourse />}
          />

          <Route
            path={"/create-course"}
            caseSensitive={false}
            element={<CreateCourse />}
          />

          <Route
            path={"/course-view/:slug"}
            caseSensitive={false}
            element={<ViewCourseByModulesAndTopic />}
          />

          <Route
            path={"/edit-course/:slug"}
            caseSensitive={false}
            element={<EditCourse />}
          />

          <Route
            path={"/all-courses"}
            caseSensitive={false}
            element={<AllCoures />}
          />

          <Route
            path={"/all-trainings"}
            caseSensitive={false}
            element={<ShowAllTrainings />}
          />
          <Route
            path={"/completed-trainings"}
            caseSensitive={false}
            element={<ShowAllCompletedTraining />}
          />

          <Route
            path={"/update-user-profile/:slug"}
            caseSensitive={false}
            element={<UpdateUserDetails />}
          />
          <Route
            path={"/users-list"}
            caseSensitive={false}
            element={<ShowAllUser />}
          />
          <Route
            path={"/completed-training-users/:slug"}
            caseSensitive={false}
            element={<JoinedTrainingUserDetails />}
          />
          <Route
            path={"/add-training-user/:slug"}
            caseSensitive={false}
            element={<AddTrainingUser />}
          />
          <Route
            path={"/show-training-users/:slug"}
            caseSensitive={false}
            element={<ShowTrainingUser />}
          />
        </Route>
        {/*Comman  Private Routes */}
        <Route
          path={"/change-password"}
          caseSensitive={false}
          element={<ChangePasswordPage />}
        />
        {/*Public Routes */}
        <Route
          path="/training-home"
          caseSensitive={false}
          element={<TraningLandingPage />}
        />
        <Route
          path="/courses"
          caseSensitive={false}
          element={<HomeAllCourses />}
        />
        <Route path="/cart" caseSensitive={false} element={<ViewCart />} />
        <Route
          path="/certifications"
          caseSensitive={false}
          element={<HomeAllCertifications />}
        />
        <Route
          path="/training-register/:slug"
          caseSensitive={false}
          element={<RegisterTrainingFrom />}
        />
        <Route
          path="/certification-details/:id"
          caseSensitive={false}
          element={<CertificationDetails />}
        />
        <Route path={"/"} caseSensitive={false} element={<MainHomePage2 />} />
        <Route path={"/login"} caseSensitive={false} element={<Login />} />
        <Route path={"/register"} caseSensitive={false} element={<SignUp />} />
        <Route
          path={"/forgot-password"}
          caseSensitive={false}
          element={<ForgotPassword />}
        />
        <Route
          path={"/reset-password/:i_t"}
          caseSensitive={false}
          element={<ResetPassword />}
        />
        <Route
          path={"/register-organization"}
          caseSensitive={false}
          element={<RegisterOrganization />}
        />
        <Route
          path="/certificate/verify/:ref_no"
          element={<VerifyCertificate />}
        />
        <Route
          path="/public/conference/:meetingId"
          element={<PublicConferencePage />}
        />
        <Route path="/not-authorized" element={<NotAuthorisedPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndCondition />} />
        <Route path="/comming-soon" element={<CommingSoon />} />
        <Route path="/*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
